<template>
  <div class="lang-picker" :class="{ 'lang-picker--compact': compact }">
    <div v-if="!compact" class="standalone-menu__label">{{ t("account.language") }}</div>
    <button
      v-for="lang in LANGUAGE_OPTIONS"
      :key="lang.code"
      type="button"
      class="sh-row lang-picker__row"
      :class="{ 'sh-row--selected': lang.code === locale }"
      :title="lang.label"
      @click="setHostLocale(lang.code)"
    >
      <img class="lang-picker__flag" :src="lang.flag" :alt="lang.label" />
      <span v-if="!compact" class="sh-row__label">{{ lang.label }}</span>
      <v-icon v-if="!compact && lang.code === locale" size="16" color="primary">check</v-icon>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useLocale } from "@i18n/vue3";
import { LANGUAGE_OPTIONS, setHostLocale } from "@/i18n/languages";

export default defineComponent({
  name: "LanguagePicker",
  props: {
    compact: { type: Boolean, default: false },
  },
  setup() {
    const { t } = useI18n();
    const locale = useLocale();
    return { t, locale, LANGUAGE_OPTIONS, setHostLocale };
  },
});
</script>

<style scoped>
.lang-picker__flag {
  width: 22px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 0 0 1px var(--sh-hairline);
}
.lang-picker--compact {
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
}
.lang-picker--compact .lang-picker__row {
  width: auto;
  padding: 4px;
  background: transparent;
}
</style>
